<ngx-spinner type="ball-spin-clockwise" size="medium">
    <p class="loading font-semibold lg:text-2xl text-white text-wrap items-center text-center">{{spinnerMessage}}</p>
</ngx-spinner>
<router-outlet></router-outlet>
<cva-standalone-cookies-consent></cva-standalone-cookies-consent>